import { StarFilled } from "@ant-design/icons";
import { Checkbox, Col, Row } from "antd";
import React from "react";
import * as _ from "lodash";

const ImageCard = ({ image, onSelect, onChecked, selectedImages }) => {
  return (
    <div
      className="card"
      style={{
        overflow: "hidden",
        borderRadius: 10,
        maxWidth: "295px",
      }}
    >
      <Row
        style={{
          cursor: "pointer",
        }}
        onClick={() => {
          onSelect();
        }}
      >
        <Col className="content-wrap">
          <img
            src={image.contentURL}
            alt={image.caption}
            style={{
              width: "100%",
              height: "inherit",
              maxHeight: 150,
              objectFit: "cover",
              zIndex: 1,
            }}
          />
          <div className="overlay">
            {" "}
            <StarFilled style={{ color: "#ffd700" }}></StarFilled>
            {image.rating}
          </div>
        </Col>
      </Row>
      <Row className="footer" >
        <Col span={2}>
          <Checkbox
            onChange={() => onChecked(image)}
            checked={_.includes(selectedImages, image)}
            className="rounded"
          ></Checkbox>
        </Col>
        <Col span={22}>
          {" "}
          <p
            style={{
              padding: "0rem",
            }}
            className="image-caption"
          >
            {image.caption ? image.caption : ""}
          </p>
        </Col>
        {/* <Col>
          <StarFilled style={{ color: "#ffd700" }} />
          <span style={{ padding: "5px" }}>{image.rating}</span>
        </Col> */}
      </Row>
    </div>
  );
};
export default ImageCard;
